import { cn } from "@/lib/utils";
import { ReactNode } from "react";
import DotPattern from "../magicui/dot-pattern";

export default function Section({ children, classList }: { children: ReactNode, classList?: string }) {
    return <section className={ cn("bg-nfPurple-800 sm:px-6 py-8 sm:py-12 z-10 relative shadow-2xl shadow-y-px shadow-spread-3 shadow-black/40 border-y-2",
        " border-nfPurple-500",
        classList)
    }>
        <DotPattern
            x={ 10 }
            y={ 10 }
            width={ 20 }
            height={ 20 }
            cr={ 2 }
            className={ cn(
                "[mask-image:linear-gradient(to_bottom_right,white,white,transparent,transparent,transparent,white,white)]",
                "fill-nfPurple-700 -z-10") }
        />
        <div className="w-11/12 max-w-screen-2xl m-auto">
            { children }
        </div>

    </section>
}
